"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const reactstrap_1 = require("reactstrap");
const __1 = require("./..");
exports.MainNavLeft = (props) => (React.createElement("div", { className: "main-nav-left" },
    React.createElement(reactstrap_1.Button, { className: "btn-icon btn-square toggle-drawer", color: "link", onClick: props.onClickMenuButton },
        React.createElement(__1.Icon, { name: "menu" })),
    React.createElement("h1", { className: "page-title" }, props.title),
    props.breadcrumbs.length !== 0 && (React.createElement(__1.Breadcrumbs, { list: props.breadcrumbs }))));
exports.MainNavLeft.displayName = 'MainNavLeft';
exports.MainNavLeft.defaultProps = {
    breadcrumbs: [],
};



//////////////////
// WEBPACK FOOTER
// ./src/components/MainNav/MainNavLeft.tsx
// module id = 360
// module chunks = 0